import _ from 'underscore'
import LightBox from '../../../components/LightBox'
import CreateProjectLightboxFooter from "./CreateProjectLightBoxFooter"
import CreateProjectLightboxHeader from './CreateProjectLightboxHeader'
import CreateProjectContent from './CreateProjectContent'
import makeRpcCall from "../../../util/jquery_rpc"
import {PROJECT_CONSTANTS} from './constants'
import messageResource from "../../../messageResource"
import {Exceptions as CommonExceptions} from '../../../common/constants'
import {NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION} from '../../common/ExceptionsTypes'

const CUSTOMER_NOT_SELECTED = "customerNotSelected";
const CUSTOMER_EXISTS = "customerExists";
const TASK_ERROR = "taskError";
const NAME_PROJECT_EMPTY = "nameProjectEmpty";
const DESCRIPTION_VERY_LARGE = "descriptionError";
const NAME_CUSTOMER_EMPTY = "customerNameEmpty";
const PROJECT_EXISTS = "projectExists";

const TAB_SWITCHING_ON_ERROR = 'details';

class CreateProjectLightbox extends LightBox {
    constructor(contentData, {
        successHandler = () => {},
        failureHandler = () => {},
        setTypesOfWorkCb = () => {},
    }) {
        super(undefined)

        this.params = {
            ...this.params,
            data: contentData,
            successHandler,
            failureHandler,
            setTypesOfWorkCb,
        }

        this.close_tab_confirmation_message_key = "project.add.js.close_tab_confirmation";
        this.exist_invalid_fields_message_key = "project.common.errormsg";
        this.cancel_confirmation_message_key = "project.add.js.cancel_confirmation";

        this.dataChanged = false;
        this.errors = {};

        this.changesCallback = function() {
            if (!this.dataChanged)
                this.dataChanged = true;
        };
    }

    init() {
        const header = new CreateProjectLightboxHeader()
        const footer = new CreateProjectLightboxFooter()
        this.content = new CreateProjectContent(
            this.params.data,
            {
                onCustomerNameChanged: this._handleCustomerNameChanged,
                onCustomerSelected: this._handleCustomerSelected,
                onProjectNameChanged: this._handleProjectNameChanged,
                onProjectNameBlur: this._handleProjectNameBlur,
                onCustomerNameBlur: this._handleCustomerNameBlur,
                onChangeCallback: this.changesCallback.bind(this),
                onDescriptionFieldChange: this.checkDescriptionOnChange.bind(this),
                getScrollPositionCallback: () => this.getScrollPosition(),
                refreshScrollCb: () => this.refreshScroll(),
            }
        )

        super.init(
            {
                id: 'createProjectPopup', // do not delete
                header,
                content: this.content,
                footer,
                classNames: 'createProjectLightbox taskProjectOrCustomerLightbox lightboxWithWhiteContent withTabs createMode',
                correctionOffset: 60 /* offset of the innerContent in the popup content used when scrolling to section with error*/
            })


        this.setSuccessCallback((projectData, tasks, addedUserIds, addedManagerIds) => {
            this._makeCreateProjectRequest(projectData, tasks, addedUserIds, addedManagerIds);
        })

        this.setFailureValidateCallback(() => this.components.content.openTabByKey(TAB_SWITCHING_ON_ERROR))

        return this
    }

    hide() {
        this.content.hide()
        super.hide()
    }

    _handleCustomerSelected = (id) => {
        this.hideError(CUSTOMER_EXISTS);
        this.hideError(CUSTOMER_NOT_SELECTED);

        if (id !== PROJECT_CONSTANTS.NEW_CUSTOMER_OPTION_INDEX) {
            this.hideError(NAME_CUSTOMER_EMPTY)
        }
    }

    _handleCustomerNameChanged = () => {
        this.hideError(CUSTOMER_EXISTS)
    }

    _handleProjectNameChanged = () => {
        this.hideError(PROJECT_EXISTS)
    }

    _handleProjectNameBlur = (field) => {
        this.checkEmpty(field, NAME_PROJECT_EMPTY, true, true);
        this.updateErrors(false);
    }

    _handleCustomerNameBlur = (field) => {
        this.checkEmpty(field, NAME_CUSTOMER_EMPTY, true, true);
        this.updateErrors(false);
    }

    getDataToCommit() {
        return this.getContent().getNewProjectData()
    }

    _changesDetected(notRequireConfirmationOnCopySettings) {
        if (this.changesCallback)
            this.changesCallback(notRequireConfirmationOnCopySettings);
    }

    _makeCreateProjectRequest(projectData, tasks, addedUserIds, addedManagerIds) {

        const self = this;
        this.disableUserInputWhileSaving();

        self.customSuccessCommitCallback = (result) => {
            if (result.taskErrorCode) {
                this.content.createTasksComponent.handleTaskError(result.taskError, result.taskErrorRowNumber)
                this.scrollToFirstTaskWithError()
            }
            else if (result.billingTypeError) {
                this.params.setTypesOfWorkCb(result['billingTypes']['list'])
                this.content.createTasksComponent.handleBillingTypeError(result.billingTypeError, result.billingTypes ? result.billingTypes.list : null)
                this.scrollToFirstTaskWithError()
            }

        }

        makeRpcCall("ProjectInfoService.createProject", [projectData, tasks, addedUserIds, addedManagerIds],
            function(result) {return self.successCommitCallback(result);},
            function(jqXHR, textStatus, errorThrown) { return self.failureCommitCallback(jqXHR, textStatus, errorThrown);});
    }

    failureCommitCallback(jqXHR, textStatus, errorThrown) {
        const self = this;

        function baseFailureHandler() {
            if (!errorThrown.exception) {
                self.enableUserInputWhileSaving();
                return false;
            }
            switch (errorThrown.exception) {
                case NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION:
                    alert(messageResource.getMessage("task.create.error.no_manage_scope_right"))
                    window.location.reload()
                    return true
                case 'com.actimind.actitime.project.ProjectExistsException':
                    self.enableUserInputWhileSaving()
                    self.displayError(PROJECT_EXISTS)
                    self.scrollToProjectName()
                    return true
                case 'com.actimind.actitime.customer.CustomerExistsException':
                    self.enableUserInputWhileSaving()
                    self.displayError(CUSTOMER_EXISTS)
                    self.scrollToCustomerSelector()
                    return true
                case CommonExceptions.USER_IS_NOT_ASSIGNED_TO_MANAGER_EXCEPTION:
                    alert(messageResource.getMessage("task.create.error.user_is_not_assigned_to_manager"))
                    window.location.reload()
                    return true
                case CommonExceptions.USER_IS_DISABLED_EXCEPTION:
                    alert(messageResource.getMessage("task.create.error.assigned_user_disabled"))
                    window.location.reload()
                    return true
                case CommonExceptions.NO_SUCH_USER_EXCEPTION:
                    alert(messageResource.getMessage("task.create.error.no_such_user"))
                    window.location.reload()
                    return true
                case CommonExceptions.USER_HAS_NO_ACCESS_TO_SCOPE_EXCEPTION:
                    alert(messageResource.getMessage("task.create.error.user_does_not_have_any_scope_rights"))
                    window.location.reload()
                    return true
                case CommonExceptions.NO_RIGHTS_TO_SUBMIT_TT_EXCEPTION:
                    alert(messageResource.getMessage("task.create.error.user_does_not_have_any_scope_rights"))
                    window.location.reload()
                    return true
            }
            if (!self.customFailureCommitCallback(jqXHR, textStatus, errorThrown)) {
                self.enableUserInputWhileSaving();
                return false;
            } else
                return true;
        }

        if (baseFailureHandler(jqXHR, textStatus, errorThrown))
            return true;

        return this.params.failureHandler(jqXHR, textStatus, errorThrown);
    }

    successCommitCallback(result) {
        const self = this;
        if (result.errorCode === PROJECT_CONSTANTS.RESULT_CODE_SUCESS) {
            if (!_.isUndefined(this.params.successHandler)) {
                this.params.successHandler(result);
                self.hide();
            }
            else
                document.location.reload();
        }

        if (result.errorCode === PROJECT_CONSTANTS.CUSTOMER_WAS_ARCHIVED) {
            alert(messageResource.getMessage('project.common.customer.archived'));
            self.content.initCustomerSelector(result.customers.list, 0);
            self.scrollToCustomerSelector();
        }

        if (result.errorCode === PROJECT_CONSTANTS.CUSTOMER_WAS_DELETED) {
            alert(messageResource.getMessage('project.common.customer.deleted'));
            self.content.initCustomerSelector(result.customers.list, 0);
            self.scrollToCustomerSelector();
        }
        self.customSuccessCommitCallback(result); // TODO lightbox
        self.enableUserInputWhileSaving(); // TODO lightbox
        self.updateUI(); // TODO lightbox
        return true;
    }

    customSuccessCommitCallback(result) {
        return true;
    }

    customFailureCommitCallback(jqXHR, textStatus, errorThrown) {
        return false;
    }

    hasErrors() {
        const classes = [];
        for (let p in this.errors)
            if (this.errors[p])
                classes.push(p);

        this.components.content.setErrorClasses(classes.join(" "))
        return classes.length > 0;
    }

    displayError(errorCode) {
        //TODO on error cb
        this.errors[errorCode] = true;
        this.updateErrors(true);
    }

    hideError(errorCode) {
        //TODO error cb
        this.errors[errorCode] = false;
        this.updateErrors(true);
    }

    _checkProjectNameValid(onlyRemoveEmptyError) {
        return !this.checkEmpty(this.components.content.getProjectNameField(), NAME_PROJECT_EMPTY, onlyRemoveEmptyError, true);
    }

    _checkCustomerId() {
        const self = this;
        const customerId = this.components.content.getCustomerId();
        if (customerId <= 0 && customerId !== PROJECT_CONSTANTS.NEW_CUSTOMER_OPTION_INDEX) {
            self.displayError(CUSTOMER_NOT_SELECTED);
            return false;
        }
        return true;
    }

    isDescriptionValid() {
        const result = this.components.content.validateDescription()
        this.errors[DESCRIPTION_VERY_LARGE] = result;

        return !result;
    }

    _checkCustomerNameValid(onlyRemoveEmptyError) {
        if (this.components.content.getCustomerId() === PROJECT_CONSTANTS.NEW_CUSTOMER_OPTION_INDEX)
            return !this.checkEmpty(this.components.content.getCustomerNameField(), NAME_CUSTOMER_EMPTY, onlyRemoveEmptyError, true);

        return true;
    }

    _checkCustomerValid() {
        const idValid = this._checkCustomerId();
        const nameValid = this._checkCustomerNameValid();
        return idValid && nameValid;
    }

    checkDescriptionOnChange() {
        this.isDescriptionValid();
        this.updateErrors(false);
    }

    updateUI() {
        this.updateErrors(true);
    }

    getErrorsMap() {
        return this.errors;
    }

    validate() {
        this.errors = {};

        let scrolled = false;
        if (!this._checkProjectNameValid()) {
            this.scrollToProjectName();
            scrolled = true;
        }

        if (!this._checkCustomerValid() && !scrolled) {
            this.scrollToCustomerSelector();
            scrolled = true;
        }

        if (!this.isDescriptionValid() && !scrolled) {
            this.scrollToDescription();
            scrolled = true;
        }

        if (!this._customValidate() && !scrolled) {
            this._customValidateScroll();
        }

        this.updateUI();

        return !this.hasErrors();
    }

    scrollToProjectName() {
        this.getWrapper().scrollToSection(this.getContent().getProjectNameField());
    }

    scrollToDescription() {
        this.getWrapper().scrollToSection(this.getContent().getDescriptionField());
    }

    scrollToCustomerSelector() {
        this.getWrapper().scrollToSection(this.getContent().getCustomerSelectorSection());
    }

    _customValidate() {

        this.errors[TASK_ERROR] = !this.components.content.getCreateTaskComponent().isEmpty() &&
                                  !this.components.content.getCreateTaskComponent().validate();

        return !this.errors[TASK_ERROR] ;
    }

    _customValidateScroll() {
        this.scrollToFirstTaskWithError();
    }

    scrollToTasksTable() {
        this.getWrapper().scrollToSection(this.components.content.find(".createTasksTable"))
    }

    scrollToFirstTaskWithError() {
        const taskWithErr = this.components.content.find(".createTasksTable .nameCell .error");

        if (taskWithErr.get(0))
            this.getWrapper().scrollToSection(taskWithErr);
        else
            this.scrollToTasksTable();
    }
}

export default CreateProjectLightbox



// WEBPACK FOOTER //
// ./web/js/taskManagement/createLightbox/project/CreateProjectLightbox.js